export default "/images/sendbat-dark.svg?74efe7e1ba6b3a0658a2f95b46854bfd";